/**
 * Invoices/Index Controller
 *
 * Displays a list of invoices
 */

// the constructor for this object
function InvoicesIndexController() { }

// the object
InvoicesIndexController.prototype = {
    constructor: InvoicesIndexController,
    
    // this contains the pagination object
    pagination: false,
    
    // the number of invoices per page
    perPage: 20,
    
    // the last data submitted to the API, used to prevent multiple api requests
    lastSubmittedData: {},
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // set up the pagination
        this._setupPagination();
        
        // build the accounts dropdown used in the invoice widget
        this._setupAccountsDropdown();
        
        PortalHelper.debugMessage('Invoices Index Initialized');
    },
    
    // run the controller
    run: function()
    {    
        // register the pagination events
        this.pagination.init();
    
        // get and populate the invoices
        this._getInvoices();
        
        // register the events used by this controller
        this._registerEvents();
        
        PortalHelper.debugMessage('Invoices Index Controller Ran');
    },
    
    // create the pagination object
    _setupPagination: function()
    {
        var pagination = new PortalPagination;
        pagination.perPage = this.perPage;
        pagination.paginationSelector = '#invoices-pagination';
        pagination.contentSelector = '#invoices-table';
        pagination.searchSelector = '#portal-search';
        pagination.searchColumn = 'search_all';
        pagination.eventCallback = PortalMain.InvoicesIndexController._getInvoices;
        PortalMain.InvoicesIndexController.pagination = pagination;
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
    },
    
    // build the accounts dropdown used in the invoice widget
    _setupAccountsDropdown: function()
    {
        // populate the accounts dropdown, and rerun the controller on change
        var invoicesAccountSelector =  new PortalAccountSelector();
        invoicesAccountSelector.setupAccountsDropdown(
            '#account-selection',
            function(currentAccountId) {
                
                PortalHelper.loadingOverlay('#invoices-table', true);
                PortalHelper.loadingOverlay('#invoices-pagination', true);
                
                PortalMain.InvoicesIndexController.pagination.setPage(1);
                
                // get the invoices using the new account id
                PortalMain.InvoicesIndexController._getInvoices();
            }
        );
        this.invoicesAccountSelector = invoicesAccountSelector;
    },
    
    // get the invoices from the api
    _getInvoices: function()
    {    
        // get the submission data from the pagination object
        var submissionData = PortalMain.InvoicesIndexController.pagination.getBaseSubmissionData();
    
        // include the account id with the data
        var currentAccountId = PortalMain.PortalAccounts.getCurrentAccountId();
        if (currentAccountId != 0) {
            submissionData.accountId = currentAccountId;
        }
        
        // make sure the new request isn't the same as the previous one
        if (JSON.stringify(submissionData) == JSON.stringify(PortalMain.InvoicesIndexController.lastSubmittedData)) {
            PortalMain.InvoicesIndexController.pagination.showPagination();
            return;
        }
        PortalMain.InvoicesIndexController.lastSubmittedData = submissionData;
        
        // make the request
        var invoicesRequest = new PortalRequest;
        invoicesRequest.pageNumber = submissionData.page;
        invoicesRequest.makeRequest(
            '/invoices/get-invoices',
            submissionData,
            function(data) {
                
                //handle pagination 
                PortalMain.InvoicesIndexController.pagination.updatePagination(data);
                PortalMain.InvoicesIndexController.pagination.showPagination();
                
                // fill the invoice chart data
                PortalMain.InvoicesIndexController._populateInvoicesTable(data);
                
            }
        );
    },
    
    // populate the invoices table
    _populateInvoicesTable: function(invoicesData)
    {    
        var invoices = invoicesData.data;
        
        // clear the old tickets
        $('#invoices-table tbody tr:not(.clone-source)').remove();
        
        // add the new tickets to the DOM
        for (var i in invoices) {
            var invoice = invoices[i];
            var newEntry = $('#invoices-table tbody .clone-source').clone();
            newEntry.removeClass('clone-source');
            
            // apply the invoice bill date
            var billDate = PortalHelper.formatDate(invoice.bill_date);
            $('.bill-date', newEntry).html(billDate);
            
            // apply the account number
            $('.account-number', newEntry).html(invoice.account_number);
            
            // apply the invoice number
            $('.invoice-number', newEntry).html(invoice.invoice_number);
            
            // apply the total charges
            var totalAmount = PortalHelper.numberToDollars(invoice.total_amt_due);
            $('.total-amount', newEntry).html(totalAmount);
            
            // set the view invoice link
            var viewLink = PortalConfig.portalUrl + '/invoices/view';
            viewLink += '/' + invoice.account_id + '/' + invoice.cycle_log_id;
            $('.view-link', newEntry).attr('href', viewLink);
            
            // add to to the table
            $('#invoices-table tbody').append(newEntry);
        }
        
    },
    
    
}